export default __webpack_public_path__ + "assets/images/23fa24962fc6439b75fd1a483006fbba.svg";